import th from './th/th.json';

export default th;
